import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from "src/app/core/services/common.service";
import { NotifierService } from "angular-notifier";
import { MatDialog } from "@angular/material/dialog";
import { Message } from "src/app/core/class/message";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { Subject, ReplaySubject,Observable } from 'rxjs';
import { ErrorCode } from "src/app/core/constants/error-code";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from '@angular/router';
import { LaborUtilizationReportService } from 'src/app/core/services/labor-utilization-report.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { TranslateService } from '@ngx-translate/core';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { format } from 'date-fns';

@Component({
  selector: 'app-config-hdld',
  templateUrl: './config-hdld.component.html',
  styleUrls: ['./config-hdld.component.scss']
})
export class ConfigHdldComponent extends BaseComponent implements OnInit, OnDestroy  {

  maSoThue: string = '0105 234 567';
  oldData: any = null
  configForm: FormGroup
  isValueFormChange: boolean = false

  searchBusinessTypeCtrl: FormControl = new FormControl(null);
  searchBusinessFieldCtrl: FormControl = new FormControl(null);
  searchProfessionCtrl: FormControl = new FormControl(null);
  pickDateReportCtrl: FormControl = new FormControl(null);

  listBusinessType: any = []
  listBusinessTypeFilter: Observable<any>;
  listBusinessField: any = []
  listBusinessFieldFilter: Observable<any>;
  listProfession: any = []
  listProfessionFilter: Observable<any>;
  listNational: any[] = [];

  destroySubject$ = new Subject<void>()
  resetData = false;

  enterpriseId: string;

  enterprisesDefaut = {
    id: null,
    name: '',
    enterpriseType: null,
    tenantId: 1,
    foreignName: '',
    parentId: null,
    abbreviation: '',
    taxCode: '',
    licenceDate: null,
    activeDate: null,
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    expiryDate: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: null,
    representativeIssuedOn: '',
    representativeIssuedAt: '',
    status: true,
    birthday: null,
    sex: '',
    adminUser: '',
    businessType: null,
    addresses: [
      {
        address: '',
        cityId: null,
        districtId: null,
        wardId: null,
        id: null,
        isNewAddress: true
      }
    ],
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    birthdayDisplay: '',
    representativeIssuedDateDisplay: '',
    issuedDateDisplay: ''
  };

  enterprises = this.enterprisesDefaut;

  private readonly ALL_DAYS: number[] = Array.from({ length: 25 }, (_, i) => i + 1);

  public DataDays: ReplaySubject<number[]> = new ReplaySubject<number[]>(1);

  MONTH = 'MONTH';
  QUARTER = 'QUARTER';
  HALF = 'HALF';
  YEAR = 'YEAR';
  CUSTOM = null;

  protected _onDestroy = new Subject<void>();
  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private fb: FormBuilder,
    private router: Router,
    public toast: ToastrService,
    public translateSvr: TranslateService,
    public route: ActivatedRoute,
    private laborUtilizationReportService: LaborUtilizationReportService,
    private enterpriseService: EnterpriseService,
  ) {
    super(commonService, message);
    this.notifier = notifier;

    this.getDataDropDown()
    this.initForm()
    this.listenChangeInputSearch()
  }

  initForm(){
    this.configForm = new FormGroup({
    national: new FormControl(null, [Validators.required]),
    authorizationGround : new FormControl(''),
      isSendMoha: new FormControl(false, [Validators.required]),
      isSendFile: new FormControl(false, [Validators.required]),
      isSendFileReport: new FormControl(false, [Validators.required]),
      businessType: new FormControl(null),
      website: new FormControl(null),
      reportAuto: new FormControl(null),
      reportDate: new FormControl(null),
      //nationality: new FormControl(null),
    })

    if (this.configForm.get('reportAuto').value === null) {
      this.configForm.controls['reportAuto'].patchValue(false);
    }

    this.configForm.controls['isSendMoha'].valueChanges.subscribe((res) => {
      if(!res){
        this.configForm.controls['isSendFile'].patchValue(false)
        this.configForm.controls['isSendFileReport'].patchValue(false)
      }
    })

    this.configForm.valueChanges.subscribe((res) => {
      if(this.configForm.dirty ){
        this.isValueFormChange = true
      }
    })

  this.configForm.get('reportAuto').valueChanges.subscribe((isAuto: boolean) => {
  const reportDateControl = this.configForm.get('reportDate');

  if (isAuto) {
    reportDateControl.setValidators([Validators.required]);
  } else {
    // 1. Gỡ bỏ validator cho cả 2 trường khi ở chế độ thủ công
    reportDateControl.clearValidators();
    // 2. Gán giá trị
    reportDateControl.patchValue(null);
  }

  // 3. Ép Angular tính toán lại trạng thái Valid/Invalid cho từng ô
  reportDateControl.updateValueAndValidity();

  // 4. Cập nhật biến để sáng nút Update
  this.isValueFormChange = true;
  this.configForm.markAsDirty();
});
  }

  ngOnInit() {
    this.getDetailData();
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.loadData(this.enterpriseId);
    this.getNationalInfo();

    this.DataDays.next(this.ALL_DAYS.slice());

    this.pickDateReportCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDays();
      });
  }

  getDetailData(){
    this.laborUtilizationReportService.getDetailConfigHDLD().subscribe((res) => {
      if(res && res.data){
        this.configForm.patchValue(res.data)
        this.oldData = {
          ...res.data,
          website: res.data.website ? res.data.website : '',
          reportDate: res.data.reportDate? res.data.reportDate : ''
        }
        setTimeout(() => {
          this.isValueFormChange = false
        }, 500)
      }
    })
  }

  getDataDropDown(){
    this.laborUtilizationReportService.getBusinessTypes().subscribe((res) => {
      const { data } = res;
      this.listBusinessType = data;
      this.searchBusinessTypeCtrl.patchValue("");
    });

    // this.laborUtilizationReportService.getBusinessFields().subscribe((res) => {
    //   const { data } = res;
    //   this.listBusinessField = data;
    //   this.searchBusinessFieldCtrl.patchValue("");
    // });

    this.laborUtilizationReportService.getProfessions().subscribe((res) => {
      const { data } = res;
      this.listProfession = data;
      this.searchProfessionCtrl.patchValue("");
    });
  }

  clearData(field: string) {
    this.configForm.get(field).patchValue(null);
  }

  listenChangeInputSearch(){
    this.listBusinessTypeFilter = this.searchBusinessTypeCtrl.valueChanges.pipe(
      takeUntil(this.destroySubject$),
      startWith(""),
      map((value) => {
        if (!value) {
          return this.listBusinessType
        }
        return this.listBusinessType.filter((st: any) => {
          const optionLabel = `${this.commonService.extractUnicode(st.ten)}`;
          return optionLabel.toLowerCase().includes(this.commonService.extractUnicode(value).trim().toLowerCase());
        });
      })
    );

    // this.listBusinessFieldFilter = this.searchBusinessFieldCtrl.valueChanges.pipe(
    //   takeUntil(this.destroySubject$),
    //   startWith(""),
    //   map((value) => {
    //     if (!value) {
    //       return this.listBusinessField
    //     }
    //     return this.listBusinessField.filter((st: any) => {
    //       const optionLabel = `${this.commonService.extractUnicode(st.ten)}`;
    //       return optionLabel.toLowerCase().includes(this.commonService.extractUnicode(value).trim().toLowerCase());
    //     });
    //   })
    // );

    this.listProfessionFilter = this.searchProfessionCtrl.valueChanges.pipe(
      takeUntil(this.destroySubject$),
      startWith(""),
      map((value) => {
        if (!value) {
          return this.listProfession
        }
        return this.listProfession.filter((st: any) => {
          const optionLabel = `${this.commonService.extractUnicode(st.ten)}`;
          const optionCode = `${this.commonService.extractUnicode(st.ma)}`;
          return (optionLabel.toLowerCase().includes(this.commonService.extractUnicode(value).trim().toLowerCase()) ||
          optionCode.toLowerCase().includes(this.commonService.extractUnicode(value).trim().toLowerCase()))
        });
      })
    );
  }

  cancelSaveForm(){
    if(this.isValueFormChange){
      const dialogRef = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.commonService.format(this.message.getMessage('messages.confirm_change_data'))
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.backUpData();
          setTimeout(() => {
            this.isValueFormChange = false
          }, 500)
          this.backUpData();
        }
      });
    }
  }

  backUpData(){
    if (this.oldData) {
      if (!this.oldData.reportDate) {
        this.oldData.reportDate = null;
      }
      this.configForm.patchValue(this.oldData, { emitEvent: false });
      this.isValueFormChange = false;
    }
  }

  actionForm(){
    this.saveForm()
  }

  saveForm(){
    let body = {
      ...this.configForm.getRawValue()
    }

    this.laborUtilizationReportService.saveConfigHDLD(body).subscribe((res) => {
      if(res){
        if (res && res.code !== "200") {
          this.toast.error(this.message.getMessage(res.message));
          return;
        }
        this.toast.success(
          this.message.getMessage(
            'labor_utilization_report.update_labor_usage_report_configuration_success'
          )
        );
        this.oldData = {
          ...body
        }
        this.isValueFormChange = false
      }
    })
  }

  ngOnDestroy(){
    this.destroySubject$.next();
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  protected filterDays() {
  if (!this.ALL_DAYS) {
    return;
  }

  let search = this.pickDateReportCtrl.value;
  if (!search) {
    this.DataDays.next(this.ALL_DAYS.slice());
    return;
  } else {
    search = search.toString().toLowerCase();
  }
  this.DataDays.next(
    this.ALL_DAYS.filter(day => day.toString().toLowerCase().indexOf(search) > -1)
  );
}

loadData(enterpriseId: string) {
  this.enterpriseService.getEnterpriseByID(enterpriseId).subscribe(rs => {
    localStorage.setItem('SignDataValidateKyc', JSON.stringify(rs.data));
    if (rs != null && rs.data != null) {
      const responsedData = rs.data;
      // if (responsedData.addresses == null || responsedData.addresses.length === 0) {
      //   responsedData.addresses = [this.defaultAddress];
      // }
      this.enterprises = responsedData;
      this.enterprises.birthdayDisplay = this.enterprises.birthday ? format(this.enterprises.birthday, 'DD/MM/YYYY') : '';
      this.enterprises.representativeIssuedDateDisplay = this.enterprises.representativeIssuedDate ? format(this.enterprises.representativeIssuedDate, 'DD/MM/YYYY') : '';
      this.enterprises.issuedDateDisplay = this.enterprises.issuedDate ? format(this.enterprises.issuedDate, 'DD/MM/YYYY') : '';
      this.enterprises.addresses[0].isNewAddress = !!responsedData.addresses[0].isNewAddress;
      this.enterprises.fax = responsedData.fax ? responsedData.fax : '';
    } else {
      this.enterprises = this.enterprisesDefaut;
    }
  });
}

getNationalInfo() {
  this.enterpriseService.getNationalList().subscribe(rs => {
    if (rs != null && rs.data != null) {
      this.listNational = rs.data.filter((item: any) => item.trang_thai === true);
    }
  });
}

onEditClick(event: Event) {
  event.stopPropagation();   // ngăn click lan ra làm toggle mat-expansion-panel
  // gọi method xử lý của bạn ở đây
  this.handleEditGeneralConfig();
}

handleEditGeneralConfig() {
  // logic thực tế khi bấm icon 
}

onClickBtnViewUpdate(){
  const id = localStorage.getItem('enterpriseId')
  this.router.navigate(['/home-enterprise/update-enterprise/'], {
    queryParams: {
      tenantId: localStorage.getItem('tenantId'),
      enterpriseId: id,
    }
  });
}
}
